import React, { useEffect, useState, useRef } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/ViewSurrender.css';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import { useParams } from "react-router-dom";
import '../css/ViewRequisition.css';
import Sidebar from './Sidebar';
import Select from "react-select";
import '../css/ReviewRequisition.css';
import { DateTime } from "luxon";
import styled from "styled-components";
import PrintButton from './PrintButton';
import ExportPDFButton from './ExportPDFButton';
import ExportExcelButton from './ExportExcelButton';
import { useMemo } from "react"; 
import PopupModal from './PopupModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCheckCircle, 
  faExclamationTriangle,
  faSpinner,
  faDollarSign  
} from '@fortawesome/free-solid-svg-icons';

const districts = [
  "Balaka", "Blantyre", "Chikwawa", "Chiradzulu", "Chitipa", "Dedza", "Dowa", "Karonga", "Kasungu",
  "Likoma", "Lilongwe", "Machinga", "Mangochi", "Mchinji", "Mulanje", "Mwanza", "Mzimba", "Neno",
  "Nkhata Bay", "Nkhotakota", "Nsanje", "Ntcheu", "Ntchisi", "Phalombe", "Rumphi", "Salima", "Thyolo", "Zomba"
];

const costDriversList = [
  "FCI Staff Perdiem",
  "Partners DSA",
  "Government Staff DSA -AEDC, AEDO LVCDO",
  "Field Staff DSA",
  "Venue/Hall Hire",
  "Snacks",
  "Refreshments",
  "Lunch Allowance",
  "Transport Refund",
  "Stationery",
  "Scanning, printing & photocopy",
  "Training Materials",
  "PA System hire",
  "Genset Hire",
  "Vehicle Hire",
  "Vehicle Fuel",
  "Toll Gate Fee",
  "Other"
];

const supportDocumentsMap = {
  "FCI Staff Perdiem": "DSA Form, Attendance Register",
  "Partners DSA": "DSA Form, Attendance Register",
  "Government Staff DSA -AEDC, AEDO LVCDO": "DSA Form, Attendance Register",
  "Field Staff DSA": "DSA Form, Attendance Register",
  "Venue/Hall Hire": "Receipt(s)",
  "Snacks": "Receipt(s)",
  "Refreshments": "Receipt(s)",
  "Lunch Allowance": "Attendance Register, Lunch Allowance Form",
  "Transport Refund": "Transport Refund Form, Attendance Register",
  "Vehicle Hire": "Millage Form/Vehicle Log Book",
  Other: "Type the support document",
  default: "Receipt(s)",
};

const StyledInput = styled.input`
  border: 1px solid #ccc;
  padding: 8px;
  font-size: 16px;
  width: 100%;

  &::placeholder {
    font-size: 12px;
    color: grey;
  }
`;

const districtOptions = districts.map(district => ({
  value: district,
  label: district
}));



const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  if (typeof dateString === "string") {
    const m = dateString.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
  }
  const d = new Date(dateString);
  if (isNaN(d)) return "";
  return d.toISOString().split("T")[0]; 
};


const formatDateForDisplay = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (isNaN(d)) return "";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
};

const formatCurrency = (value) => {
  if (value == null || value === "" || Number(value) === 0) return "0";
  const num = Number(value) || 0;
  return `MK ${num.toLocaleString('en-US')}`;
};

const toNumber = (v) => {
  if (v == null) return 0;
  const cleaned = String(v).replace(/mk/i, "").replace(/,/g, "").trim();
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : 0;
};



const formatCurrencyForSecondTable = (value) => {
  const num = toNumber(value);       
  if (num === 0) return "0";         
  return `MK ${num.toLocaleString("en-US")}`;
};



const ViewSurrender = () => {
const [showCompleteModal, setShowCompleteModal] = useState(false);
const [showTooltip, setShowTooltip] = useState(false);
const [highlightNextLabel, setHighlightNextLabel] = useState(false);
const [isCompleting, setIsCompleting] = useState(false);


const [users, setUsers] = useState([]); 
const [isConfirmed, setIsConfirmed] = useState(false);
const signatureFilePath = localStorage.getItem("signatureFilePath");
const fullName = localStorage.getItem('fullName') || "Name";
const currentUser = { id: localStorage.getItem('userId') };
const [reviewers, setReviewers] = useState([]);

const [reviewData, setReviewData] = useState({
  nextReviewerId: '',
  currentReviewerNumber: null
});
  
  const { requisitionID } = useParams();
  const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5259";

  const [surrender, setSurrender] = useState(null);
  const [local, setLocal] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [costDriverOptions] = useState(costDriversList.map(cd => ({ value: cd, label: cd })));
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const contentRef = useRef(null); 
  const theUserType = localStorage.getItem('userType'); 
  const isSurrenderReviewer = (theUserType || "").toLowerCase() === "surrender reviewer";

  const [hasChanges, setHasChanges] = useState(false);
  const formData = new FormData();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
   const [costDriversData, setCostDriversData] = useState([
     {
       costDriver: "",
       quantity: "",
       unitPrice: "",
       actualSpent: "",
       selectedFiles: [],
       isCustom: false,
       isNew: false, 
       attachmentType: "" 
     },
   ]);
 const [requisition, setRequisition] = useState(null);
   
 const [surrenderFormData, setSurrenderFormData] = useState({
    districtAndAreaProgramPairs: [],
    numberOfClientsAchieved: ''
  });

  const [costDriverActuals, setCostDriverActuals] = useState([]);
const getUserId = (u) => u.id ?? u.Id ?? u.userName ?? u.email;
const currentUserId = localStorage.getItem("userId") || localStorage.getItem("userID") || localStorage.getItem("id") || null;

const currentReviewer = (users || []).find(u => getUserId(u) === (currentUserId ?? null));



const allowedReviewerTypes = ["surrender reviewer users", "reviewer user"];

const [nextReviewerId, setNextReviewerId] = useState("");


const currentReviewerNumber = Number(
  currentReviewer?.reviewerNumber ??
  currentReviewer?.ReviewerNumber ??
  localStorage.getItem("reviewerNumber") ??
  0
);

const reviewerOptions = (users || [])
.filter(u => {
  const ut = (u.userType || "").toString().toLowerCase();
  return allowedReviewerTypes.includes(ut);
})
.map(u => ({
  value: getUserId(u),
  label: `${(u.firstName||"").trim()} ${(u.lastName||"").trim()}`.trim(),
  reviewerNumber: Number(u.reviewerNumber ?? u.ReviewerNumber ?? 0),
  raw: u
}));



const fetchSurrenderData = async () => {
  try {
    setLoading(true);
    const response = await axios.get(`${API_BASE}/api/surrender/${requisitionID}`);
    const data = response.data || {};

    const costDriverActuals = Array.isArray(data.costDriverActuals)
      ? data.costDriverActuals.map(cd => ({
          ...cd,
          costDriver: cd.costDriver ?? "",
          customCostDriver: cd.customCostDriver ?? "",
          isCustom: cd.isCustom ?? false,
          quantity: cd.quantity ?? "",
          unitPrice: cd.unitPrice ?? "",
          actualSpent: cd.actualSpent ?? "",
          attachmentType: cd.attachmentType ?? "physical",
          selectedFiles: [], 
          supportDocuments: Array.isArray(cd.supportDocuments) ? cd.supportDocuments : [],
          justification: cd.justification || "",
          isNew: !!cd.isNew
        }))
      : [];

    const blastingCostDriverActuals = Array.isArray(data.blastingCostDriverActuals)
      ? data.blastingCostDriverActuals.map(cd => ({
          ...cd,
          costDriver: cd.costDriver ?? "",
          customCostDriver: cd.customCostDriver ?? "",
          isCustom: cd.isCustom ?? false,
          quantity: cd.quantity ?? "",
          unitPrice: cd.unitPrice ?? "",
          actualSpent: cd.actualSpent ?? "",
          attachmentType: cd.attachmentType ?? "physical",
          selectedFiles: [], 
          supportDocuments: Array.isArray(cd.supportDocuments) ? cd.supportDocuments : [],
          justification: cd.justification || "",
          isNew: !!cd.isNew
        }))
      : [];

    const advanceActualsAndVariances = Array.isArray(data.advanceActualsAndVariances)
      ? data.advanceActualsAndVariances
      : [];

    const blastingAdvanceActualsAndVariances = Array.isArray(data.blastingAdvanceActualsAndVariances)
      ? data.blastingAdvanceActualsAndVariances
      : [];
      
    const districtPairs = Array.isArray(data.districtAndAreaProgramPairsActuals)
      ? data.districtAndAreaProgramPairsActuals
      : [];

const pickDateField = (obj, candidates) => {
for (const k of candidates) {
  if (obj && obj[k] != null && obj[k] !== "") return obj[k];
}
return undefined;
};

const mapped = {
...data,
costDriverActuals,
blastingCostDriverActuals,
advanceActualsAndVariances,
blastingAdvanceActualsAndVariances,
districtAndAreaProgramPairsActuals: districtPairs,
from: pickDateField(data, ['from', 'fromDate', 'From', 'FromDate', 'fromDateString', 'from_date', 'From_Date']),
to:   pickDateField(data, ['to', 'toDate', 'To', 'ToDate', 'toDateString', 'to_date', 'To_Date'])
};

console.log('API data keys:', Object.keys(data || {}));
console.log('picked mapped.from =>', mapped.from, ' mapped.to =>', mapped.to);

setSurrender(mapped);


setLocal({
from: formatDateForInput(mapped.from),
to: formatDateForInput(mapped.to),
numberOfClientsAchieved: mapped.numberOfClientsAchieved ?? "",
country: mapped.country ?? "",      
districtPairs: (mapped.districtAndAreaProgramPairsActuals || []).map(p => ({ ...p })),
costDriverActuals: (mapped.costDriverActuals || []).map(cd => ({
  id: cd.id ?? null,
  costDriverNumber: cd.costDriverNumber ?? null,
  costDriver: cd.costDriver ?? "",
  customCostDriver: cd.customCostDriver ?? "",
  isCustom: cd.isCustom ?? false,
  quantity: cd.quantity ?? "",
  unitPrice: cd.unitPrice ?? "",
  actualSpent: cd.actualSpent ?? "",
  attachmentType: cd.attachmentType ?? "physical",
  selectedFiles: [],
  supportDocuments: cd.supportDocuments || [],
  justification: cd.justification || "",
  isNew: !!cd.isNew
})),
blastingCostDriverActuals: (mapped.blastingCostDriverActuals || []).map(cd => ({
  id: cd.id ?? null,
  costDriverNumber: cd.costDriverNumber ?? null,
  costDriver: cd.costDriver ?? "",
  customCostDriver: cd.customCostDriver ?? "",
  isCustom: cd.isCustom ?? false,
  quantity: cd.quantity ?? "",
  unitPrice: cd.unitPrice ?? "",
  actualSpent: cd.actualSpent ?? "",
  attachmentType: cd.attachmentType ?? "physical",
  selectedFiles: [],
  supportDocuments: cd.supportDocuments || [],
  justification: cd.justification || "",
  isNew: !!cd.isNew
}))
});

  } catch (err) {
    console.error("Error fetching surrender:", err);
    setError(err?.message || "Error fetching surrender");
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  const fetchReviewers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/users/reviewers`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setReviewers(response.data);
      } catch (error) {
        console.error("Error fetching reviewers:", error);
      }
    };
    
    fetchReviewers();
  }, []);

useEffect(() => {
  fetchSurrenderData();
}, [requisitionID]);


  useEffect(() => {
    const fetchRequisitionDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/Requisition/${requisitionID}`
        );
  
        const data = response.data;
        setRequisition(data);
  
        const districtPairs = Array.isArray(data.districtAndAreaProgramPairs)
          ? data.districtAndAreaProgramPairs
          : [];
  
        setSurrenderFormData({
          districtAndAreaProgramPairs: districtPairs.map(pair => ({
            district: pair.district,
            areaProgram: pair.areaProgram,
          })),
        });
  
        const costDrivers = Array.isArray(data.costDrivers)
          ? data.costDrivers
          : [];
  
        setCostDriversData(
          costDrivers.map(driver => ({
            costDriver: driver.costDriver,
            quantity: "", 
            unitPrice: "", 
            actualSpent: driver.actualSpent || "",
            selectedFiles: [],
          }))
        );
  
        setCostDriverActuals(
          costDrivers.map(driver => ({
            costDriver: driver.costDriver,
            quantity: "", 
            unitPrice: "", 
            actualSpent: driver.actualSpent || "",
            selectedFiles: [],
          }))
        );
  
       
  
        if (data.from && data.to) {
          const fromDate = new Date(data.from);
          const toDate = new Date(data.to);
  
          const localFromDate = new Date(
            fromDate.getTime() - fromDate.getTimezoneOffset() * 60000
          ).toISOString().split("T")[0];
  
          const localToDate = new Date(
            toDate.getTime() - toDate.getTimezoneOffset() * 60000
          ).toISOString().split("T")[0];
  
          setFrom(localFromDate);
          setTo(localToDate);
  
          if (districtPairs.length > 0) {
            setSurrenderFormData({
              districtAndAreaProgramPairs: districtPairs.map(pair => ({
                district: pair.district,
                areaProgram: pair.areaProgram,
              })),
            });
          }
        }
      } catch (error) {
        console.error("Error fetching requisition details:", error);
      }
    };
  
    fetchRequisitionDetails();
  }, [requisitionID]);


  useEffect(() => {
    if (!reviewerOptions || reviewerOptions.length === 0) return;
    const target = reviewerOptions.find(r => r.reviewerNumber === currentReviewerNumber + 1);
    setNextReviewerId(target ? target.value : (reviewerOptions[0]?.value ?? ""));
  }, [reviewerOptions, currentReviewerNumber]);


  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/users`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    
    fetchUsers();
  }, []);
  
  useEffect(() => {
    if (users.length === 0) return;
  
    const allowedTypes = ["Reviewer", "Surrender Reviewer"];
    const filtered = users.filter(user => 
      allowedTypes.includes(user.userType) && 
      user.id !== currentUser.id
    );
    
    setReviewers(filtered);
  }, [users, currentUser.id]);
  

  
if (loading) return <div>Loading surrender data...</div>;
  if (error) return <div>Sorry an Error has occured. {error}</div>;
  if (!surrender || !local) return <div>Loading…</div>;

  const getSupportDocuments = (costDriverName) => supportDocumentsMap[costDriverName] ?? supportDocumentsMap.default;
  const getDefaultUnitPrice = (costDriverName) => {
    return 0;
  };

  const addDistrictPairLocal = () => setLocal(l => ({ ...l, districtPairs: [...(l.districtPairs || []), { district: "", areaProgram: "" }] }));
  const removeDistrictPairLocal = (idx) => setLocal(l => ({ ...l, districtPairs: l.districtPairs.filter((_, i) => i !== idx) }));
  const handleLocalDistrictChange = (index, selectedOption) => {
    setLocal(prev => {
      const arr = [...(prev.districtPairs || [])];
      arr[index] = { ...arr[index], district: selectedOption ? selectedOption.value : "" };
      return { ...prev, districtPairs: arr };
    });
  };
  const handleLocalAreaProgramChange = (index, value) => {
    setLocal(prev => {
      const arr = [...(prev.districtPairs || [])];
      arr[index] = { ...arr[index], areaProgram: value };
      return { ...prev, districtPairs: arr };
    });
  };

  const handleCostDriverSelectChange = (index, selectedOption) => {
    setLocal(prev => {
      const arr = [...(prev.costDriverActuals || [])];
      if (!selectedOption) {
        arr[index] = { ...arr[index], costDriver: "", isCustom: false, customCostDriver: "", supportDocuments: getSupportDocuments(""), unitPrice: "" };
      } else if (selectedOption.value === "Other") {
        arr[index] = { ...arr[index], costDriver: "", isCustom: true, customCostDriver: "", supportDocuments: "", unitPrice: "" };
      } else {
        arr[index] = { ...arr[index], costDriver: selectedOption.value, isCustom: false, customCostDriver: "", supportDocuments: getSupportDocuments(selectedOption.value), unitPrice: getDefaultUnitPrice(selectedOption.value) };
      }
      return { ...prev, costDriverActuals: arr };
    });
  };

  const handleCustomCostDriverChange = (index, value) => setLocal(prev => { const arr = [...(prev.costDriverActuals || [])]; arr[index] = { ...arr[index], customCostDriver: value }; return { ...prev, costDriverActuals: arr }; });

  const handleLocalInputChange = (index, field, rawValue) => {
    setLocal(prev => {
      const arr = [...(prev.costDriverActuals || [])];
      const item = { ...(arr[index] || {}) };

      if (field === 'quantity' || field === 'unitPrice' || field === 'actualSpent') {
        item[field] = rawValue === "" ? "" : Number(rawValue);
      } else {
        item[field] = rawValue;
      }

      if (field === 'actualSpent' && item.unitPrice) {
        const up = Number(item.unitPrice) || 0;
        if (up > 0 && item.actualSpent !== "") item.quantity = Number(item.actualSpent) / up;
      } else if (field === 'quantity' && item.unitPrice !== "" && item.unitPrice != null) {
        const up = Number(item.unitPrice) || 0;
        item.actualSpent = (Number(item.quantity) || 0) * up;
      } else if (field === 'unitPrice' && item.quantity !== "" && item.quantity != null) {
        item.actualSpent = (Number(item.quantity) || 0) * (Number(item.unitPrice) || 0);
      }

      arr[index] = item;
      return { ...prev, costDriverActuals: arr };
    });
  };

  const addLocalRow = () => {
    setLocal(prev => {
      const arr = Array.isArray(prev.costDriverActuals) ? [...prev.costDriverActuals] : [];
      arr.push({
        costDriver: "",
        customCostDriver: "",
        isCustom: false,
        quantity: "",
        unitPrice: "",
        actualSpent: "",
        supportDocuments: "",
        attachmentType: "physical",
        selectedFiles: [],
        isNew: true
      });
      return { ...prev, costDriverActuals: arr };
    });
  };

  const removeLocalRow = (index) => setLocal(prev => ({ ...prev, costDriverActuals: [...(prev.costDriverActuals || [])].filter((_, i) => i !== index) }));

  const handleSupportDocumentsCheckboxChange = (index, attachmentType) => {
    setLocal(prev => {
      const arr = [...(prev.costDriverActuals || [])];
      arr[index] = { ...arr[index], attachmentType };
      if (attachmentType === "physical") arr[index].selectedFiles = [];
      return { ...prev, costDriverActuals: arr };
    });
  };

  const handleFileChange = (index, event) => {
    const files = Array.from(event.target.files || []);
    const valid = files.filter(f => f.type === "application/pdf");
    if (valid.length !== files.length) {
      setPopupMessage("Only PDF files are allowed.");
      setShowPopup(true);
    }
    setLocal(prev => {
      const arr = [...(prev.costDriverActuals || [])];
      const existing = arr[index].selectedFiles || [];
      const newUnique = [...existing];
      valid.forEach(f => {
        const duplicate = newUnique.some(e => e.name === f.name && e.size === f.size && e.lastModified === f.lastModified);
        if (!duplicate) newUnique.push(f);
      });
      arr[index] = { ...arr[index], selectedFiles: newUnique };
      return { ...prev, costDriverActuals: arr };
    });
    try { event.target.value = ""; } catch (e) {}
  };

  const closePopup = () => { setShowPopup(false); setPopupMessage(""); };

  const localActualsTotal = (local.costDriverActuals || []).reduce((sum, d) => sum + (Number(d.actualSpent) || 0), 0);
  const blastingLocalActualsTotal = (local.blastingCostDriverActuals || []).reduce((sum, d) => sum + (Number(d.actualSpent) || 0), 0);
  const advanceTotals = (surrender.advanceActualsAndVariances || []).reduce((sum, a) => sum + Number(a.advance || 0), 0);
  const blastingAdvanceTotals = (surrender.blastingAdvanceActualsAndVariances || []).reduce((sum, a) => sum + Number(a.advance || 0), 0);
  const varianceTotal = (surrender.advanceActualsAndVariances || []).reduce((sum, a, idx) => {
    const adv = Number(a.advance || 0);
    const actual = Number(local.costDriverActuals?.[idx]?.actualSpent || 0);
    return sum + (adv - actual);
  }, 0);
  const blastingVarianceTotal = (surrender.blastingAdvanceActualsAndVariances || []).reduce((sum, a, idx) => {
    const adv = Number(a.advance || 0);
    const actual = Number(local.blastingCostDriverActuals?.[idx]?.actualSpent || 0);
    return sum + (adv - actual);
  }, 0);

const totalVariance = Number(varianceTotal || 0);
const blastingTotalVariance = Number(blastingVarianceTotal || 0);
const EPS = 0.005; 
const isZeroVariance = Math.abs(totalVariance) < EPS;
const isBlastingZeroVariance = Math.abs(blastingTotalVariance) < EPS;


  const handleNextReviewerClick = async (event) => {
    try {
      event?.preventDefault?.();
  
      if (!reviewData?.nextReviewerId) {
        alert("Please select a reviewer first");
        return;
      }
  
      if (!isConfirmed) {
        alert("Please confirm that you have reviewed this surrender (check the box).");
        return;
      }
  
      const token = localStorage.getItem("token") || "";
  
      const currentReviewerId =
        currentUser?.id ?? currentUserId ?? localStorage.getItem("userId") ?? localStorage.getItem("userID") ?? "";
  
      const payload = {
        Status: `Reviewed by ${fullName || ""}`,
        NextReviewerId: reviewData.nextReviewerId,
        CurrentReviewerId: currentReviewerId,
        ReviewersId: currentReviewerId,
        RequesterID: surrender?.userId ?? surrender?.userID ?? "",
        RequesterName: surrender?.staffName ?? surrender?.staffName ?? "",
        SendNotificationToNextReviewer: true
      };
  
      const url = `${API_BASE}/api/surrender/${encodeURIComponent(requisitionID)}/status`;
  
      const response = await axios.put(url, payload, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
          "Content-Type": "application/json"
        }
      });
  
      if (response && response.status >= 200 && response.status < 300) {
        alert("Surrender sent to next reviewer successfully.");
        setReviewData(prev => ({ ...prev, nextReviewerId: "" }));
        setIsConfirmed(false);
  
        window.location.reload();
      } else {
        const errMsg = response?.data ? JSON.stringify(response.data) : `Server returned ${response?.status}`;
        alert(`Failed to send surrender: ${errMsg}`);
      }
    } catch (err) {
      console.error("Error updating surrender:", err);
      const serverMsg = err?.response?.data || err?.response?.data?.message || err?.message;
      alert(`Failed to send surrender to next reviewer${serverMsg ? `: ${serverMsg}` : ""}`);
    }
  };
  

const handleCompleteNo = () => {
  setHighlightNextLabel(true);
  setShowTooltip(true);

  setTimeout(() => {
    setHighlightNextLabel(false);
    setShowTooltip(false);
  }, 3000);
};

const handleCompleteYes = () => {
  setShowCompleteModal(true);
};

const handleCancelComplete = () => {
  setShowCompleteModal(false);
};

const handleConfirmComplete = async () => {
  if (isCompleting) return;
  setIsCompleting(true);

  try {
    const token = localStorage.getItem("token") || "";
    const currentReviewerId = currentUser?.id ?? currentUserId ?? localStorage.getItem("userId") ?? "";
    
    if (!surrender?.userId && !surrender?.userID) {
      throw new Error("Cannot determine requester ID");
    }

    const payload = {
      Status: "Surrender Review Process Complete",
      NextReviewerId: "", 
      CurrentReviewerId: currentReviewerId,
      ReviewersId: currentReviewerId,
      RequesterID: surrender?.userId ?? surrender?.userID ?? "",
      RequesterName: surrender?.staffName ?? "",
      SendNotificationToNextReviewer: false
    };

    console.log("Sending payload:", payload); 

    const url = `${API_BASE}/api/surrender/${encodeURIComponent(requisitionID)}/status`;
    const response = await axios.put(url, payload, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json"
      }
    });

    if (response && response.status >= 200 && response.status < 300) {
      setShowCompleteModal(false);
      alert("Surrender marked as complete. The requester will be notified.");
      await fetchSurrenderData(); 
    } else {
      const msg = response?.data ? JSON.stringify(response.data) : `Server returned ${response?.status}`;
      throw new Error(msg);
    }
  } catch (err) {
    console.error("Error marking surrender complete:", err);
    alert(`Failed to mark surrender complete: ${err.message}`);
  } finally {
    setIsCompleting(false);
  }
};

const getStatusClass = (status) => {
  if (status === "Draft") return "status-draft"; 
  if (status === "Submitted") return "status-submitted";
  if (status === "Surrender Submitted") return "status-surrender-submitted";
  if (status.startsWith("Reviewed by")) return "status-reviewed";
  if (status === "Approved") return "status-approved";
  if (status === "Surrender Approved") return "status-surrender-approved";
  if (status === "Disapproved") return "status-disapproved"; 
  if (status === "Disbursed") return "status-disbursed"; 
  if (status === "To be disbursed") return "status-to-be-disbursed"; 
  if (status === "Surrender Review Process Complete") return "status-surrender-review-process-complete"; 

  

  
  return ""; 
};




  return (
    <div id="wrapper">
      <Sidebar userType={theUserType} />

      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3"><i className="fa fa-bars" /></button>

            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
              <div className="input-group">
                <input type="text" className="form-control bg-light border-0 small" placeholder="Search" aria-label="Search" aria-describedby="basic-addon2" />
                <div className="input-group-append"><button className="btn btn-primary" type="button"><i className="fas fa-search fa-sm" /></button></div>
              </div>
            </form>

            <ul className="navbar-nav ml-auto"><TopBarIcons /></ul>
          </nav>

          <div className="container-fluid">
            <div className="view-requisition-header">
              <Link className="nav-link" to="/surrenders"><i className="fas fa-arrow-left back-button" /></Link>
              <h1 className="h3">Surrender</h1>
            </div>

            <div className="surrender-view-status-container">
              <div><strong>Status:</strong></div>
              <div className={`badge ${getStatusClass(surrender.status)}`}>
                {surrender.status}
              </div>
            </div>

            {surrender?.status && surrender.status.trim().toLowerCase() === "Surrender Review Process Complete" && (
              <div className="surrender-complete-variance" style={{ marginTop: 12 }}>
                {totalVariance > EPS && (
                  <div>
                    <FontAwesomeIcon icon={faDollarSign} className="surrender-currency-icon" />
                    <strong>Return:</strong> {formatCurrencyForSecondTable(totalVariance)} to the Office.
                  </div>
                )}

                {totalVariance < -EPS && (
                  <div>
                    <FontAwesomeIcon icon={faDollarSign} className="surrender-currency-icon" />
                    The Office owes you a refund of <strong>{formatCurrencyForSecondTable(Math.abs(totalVariance))}</strong>.
                  </div>
                )}

                {Math.abs(totalVariance) <= EPS && (
                  <div>
                    <FontAwesomeIcon icon={faDollarSign} className="surrender-currency-icon" />
                     No variance — nothing is owed by you or the Office.
                  </div>
                )}
              </div>
            )}



          {/* Surrender Process Complete Message */}
          {surrender?.status && surrender.status.trim().toLowerCase() === "surrender review process complete" && (
            <div 
              className="surrender-action-required animated-alert"
              style={{
                marginTop: '15px',
                marginBottom: '15px',
                padding: '12px 16px',
                backgroundColor: '#ff9800',
                border: '2px solid #f57c00',
                borderRadius: '6px',
                fontSize: '14px',
                maxWidth: 'fit-content',
                color: '#000',
                fontWeight: '500',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                position: 'relative'
              }}
            >
              {/* Pulsing circle around the div */}
              <div 
                style={{
                  position: 'absolute',
                  top: '-8px',
                  left: '-8px',
                  right: '-8px',
                  bottom: '-8px',
                  border: '2px solid #ff9800',
                  borderRadius: '10px',
                  animation: 'pulseCircle 2s infinite',
                  pointerEvents: 'none'
                }}
              />
              
              {totalVariance > EPS && (
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px', position: 'relative', zIndex: 1 }}>
                  <FontAwesomeIcon icon={faDollarSign} style={{ marginRight: '8px', color: '#28a745' }} />
                  <strong>{surrender?.staffName || "The submitter"}</strong>,
                  <span>please return</span>
                  <strong style={{ marginLeft: '4px', marginRight: '4px' }}>{formatCurrencyForSecondTable(totalVariance)}</strong>
                  <span>to the office.</span>
                </div>
              )}
              {totalVariance < -EPS && (
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px', position: 'relative', zIndex: 1 }}>
                  <FontAwesomeIcon icon={faDollarSign} style={{ marginRight: '8px', color: '#dc3545' }} />
                  <strong>{surrender?.staffName || "The submitter"}</strong>,
                  <span>please request the Administration department to refund you</span>
                  <strong style={{ marginLeft: '4px', marginRight: '4px' }}>{formatCurrencyForSecondTable(Math.abs(totalVariance))}</strong>
                  <span>.</span>
                </div>
              )}
              {Math.abs(totalVariance) <= EPS && (
                <div style={{ display: 'flex', alignItems: 'center', position: 'relative', zIndex: 1 }}>
                  <FontAwesomeIcon icon={faCheckCircle} style={{ marginRight: '8px', color: '#28a745' }} />
                  <span>No action required. Thank you.</span>
                </div>
              )}
            </div>
          )}  
  
            <div className="buttons-container">
              <PrintButton targetId="printable-area" />
              <ExportExcelButton formArray={[]} setFormArray={() => {}} currentFormData={{}} fileName="SurrenderReview.xlsx" />
              <ExportPDFButton contentRef={contentRef} />
            </div>

          
            <div id="printable-area" ref={contentRef} style={{ padding: '20px' }}>
              <form>
                <div className="requisition-details">
                  <div className="view-requisition-date-and-id" id="status">
                    <div>
                      <label><strong>Surrender Date: </strong></label>
                      <input type="text" value={surrender?.surrenderDate ? DateTime.fromISO(surrender.surrenderDate).toFormat('dd/MM/yyyy') : ''} readOnly  />
                   
                    </div>
                    <p><strong>Requisition ID:</strong> {surrender?.requisitionID}</p>
                  </div>

                  <div className="staff-activity-container">
                    <div className="form-group">
                      <h3>Staff Details</h3>
                      <div className="form-field"><label>Staff Name:</label><input type="text" value={surrender?.staffName || ''} readOnly className="read-only" /></div>
                    </div>

                    <div className="form-group">
                        <h3>Activity Details</h3>
                      <div className="form-field">
                      <div className="field-container">
                      <label>From:</label>
                        <input
                          type="date"
                          name="from"
                          value={local.from || ""}
                          onChange={(e) => setLocal(l => ({ ...l, from: e.target.value }))}
                        />
                        <label>To:</label>
                        <input
                          type="date"
                          name="to"
                          value={local.to || ""}
                          onChange={(e) => setLocal(l => ({ ...l, to: e.target.value }))}
                        />
                      </div>



                      </div>     
                                       
                        

                      <br />
                      <div className="form-field"><label>Activity Name:</label><input type="text" value={surrender?.activityName || ''} readOnly className="read-only" /></div>

                      <div className="form-field">
                        <label>Activity Purpose:</label>
                        <input type="text" value={surrender?.activityPurpose || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Target Client:</label>
                        <input type="text" value={surrender?.targetClient || ''} readOnly className="read-only" />
                      </div>

                      <div className="form-field">
                        <label>Number of Clients Achieved:</label>
                        <input value={local.numberOfClientsAchieved} onChange={e => setLocal(l => ({ ...l, numberOfClientsAchieved: Number(e.target.value) }))} />
                      </div>
                    
                      <div className="form-field">
                        <label>Expected Impact:</label>
                        <input type="text" value={surrender?.expectedImpact || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Achieved Impact:</label>
                        <input type="text" value={surrender?.achievedImpact || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label><strong>BTO Report:</strong></label>
                        {surrender?.btoReportPath ? (
                          <div style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              marginTop: "0.25rem",
                            }}
                          >
                            <a
                              href={`${process.env.REACT_APP_API_BASE_URL}/surrender/view-bto/${surrender.requisitionID}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              title="View BTO Report"
                            >
                              {surrender.btoReportPath.split("/").pop()}
                            </a>
                            
                          </div>
                        ) : (
                          <p style={{ fontStyle: "italic", color: "#666" }}>No BTO Report uploaded.</p>
                        )}
                      </div>

                      <div className="form-field">
                      <label>Country:</label>
                      <input
                        type="text"
                        value={local.country || ''}
                        onChange={e => setLocal(l => ({ ...l, country: e.target.value }))}
                      />
                      </div>

                      <h3>District and Area Program</h3>
                      <div className="district-area-container">
                        {local.districtPairs && local.districtPairs.length > 0 ? (
                          local.districtPairs.map((pair, idx) => (
                            <div key={idx} className="field-container">
                              <div className="form-field">
                                <label>District:</label>
                                <Select options={districtOptions} value={districtOptions.find(o => o.value === pair.district) || null} isClearable onChange={(opt) => handleLocalDistrictChange(idx, opt)} className="custom-select-control" />
                              </div>

                              <div className="form-field">
                                <label>Area Program:</label>
                                <input type="text" value={pair.areaProgram || ""} onChange={e => handleLocalAreaProgramChange(idx, e.target.value)} />
                              </div>

                              {idx === 0 ? <button type="button" className="add-button" onClick={addDistrictPairLocal}>+</button> : <button type="button" className="remove-button" onClick={() => removeDistrictPairLocal(idx)}>X</button>}
                            </div>
                          ))
                        ) : (
                          <div className="field-container">
                            <div className="form-field"><label>District:</label><Select options={districtOptions} value={null} isDisabled className="custom-select-control" /></div>
                            <div className="form-field"><label>Area Program:</label><input type="text" value="" readOnly className="read-only" /></div>
                          </div>
                        )}
                      </div>
                      <div className="form-field">
                        <label>Hub Office:</label>
                        <input type="text" value={surrender?.hubOffice || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Status:</label>
                        <input type="text" value={surrender?.status || ''} readOnly className="read-only" />
                      </div>
                    </div>


<div className="form-group">
                      <h3>Project & Advance Details</h3>
                      <div className="form-field">
                        <label>Project Code:</label>
                        <input type="text" value={surrender?.projectCode || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Project Name:</label>
                        <input type="text" value={surrender?.projectName || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Budget Line Code:</label>
                        <input type="text" value={surrender?.budgetLineCode || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Pay Mode:</label>
                        <input type="text" value={surrender?.payMode || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Bank Name:</label>
                        <input type="text" value={surrender?.bankName || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Account Number:</label>
                        <input 
                          type="text" 
                          value={surrender?.bankAccount || ''} 
                          readOnly 
                          className="read-only" 
                        />
                      </div>
                      <div className="form-field">
                        <label>Phone Number:</label>
                        <input type="text" value={surrender?.phoneNumber || ''} readOnly className="read-only" />
                      </div>
                    </div>
                  




                    
                  </div>

                  {/* ===== BLASTING COST DRIVERS – ACTUALS TABLE ===== */}
                  <div className="details-group">
                    <div id="blasting-cost-drivers-wrapper">
                      <div id="blasting-div">
                        <h3 id="blasting-heading">Blasting Cost Drivers – Actuals</h3>
                      </div>
                      <table className="table-bordered">
                        <thead>
                          <tr>
                            <th>Cost Driver</th>
                            <th>Quantity</th>
                            <th>Unit Price</th>
                            <th>Actual Spent</th>
                            <th>Support Documents</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(local.blastingCostDriverActuals) && local.blastingCostDriverActuals.length > 0 ? (
                            local.blastingCostDriverActuals.map((item, index) => {
                              const isNew = !!item.isNew;
                              return (
                                <tr key={`blasting-${index}`} className={isNew ? "new-row" : ""}>
                                  <td>
                                    {item.isCustom ? (
                                      <input
                                        type="text"
                                        value={item.costDriver}
                                        onChange={(e) =>
                                          handleCustomCostDriverChange(index, e.target.value)
                                        }
                                        className="form-control"
                                        placeholder="Type the Cost Driver"
                                      />
                                    ) : (
                                      <div className="dropdown-wrapper">
                                        {isNew && (
                                          <span className="over-expenditure-text">
                                            Over-expenditure
                                          </span>
                                        )}
                                        <select
                                          value={item.costDriver}
                                          onChange={(e) =>
                                            handleLocalInputChange(index, "costDriver", e.target.value)
                                          }
                                          className="form-control cost-driver-dropdown"
                                        >
                                          <option value="">Select Cost Driver</option>
                                          <option value="FCI Staff Perdiem">FCI Staff Perdiem</option>
                                          <option value="Partners DSA">Partners DSA</option>
                                          <option value="Government Staff DSA -AEDC, AEDO LVCDO">
                                            Government Staff DSA -AEDC, AEDO LVCDO
                                          </option>
                                          <option value="Field Staff DSA">Field Staff DSA</option>
                                          <option value="Venue/Hall Hire">Venue/Hall Hire</option>
                                          <option value="Snacks">Snacks</option>
                                          <option value="Refreshments">Refreshments</option>
                                          <option value="Lunch Allowance">Lunch Allowance</option>
                                          <option value="Transport Refund">Transport Refund</option>
                                          <option value="Stationery">Stationery</option>
                                          <option value="Scanning, printing & photocopy">
                                            Scanning, printing & photocopy
                                          </option>
                                          <option value="Training Materials">
                                            Training Materials
                                          </option>
                                          <option value="PA System hire">PA System hire</option>
                                          <option value="Genset Hire">Genset Hire</option>
                                          <option value="Vehicle Hire">Vehicle Hire</option>
                                          <option value="Vehicle Fuel">Vehicle Fuel</option>
                                          <option value="Toll Gate Fee">Toll Gate Fee</option>
                                          <option value="Other">Other</option>
                                        </select>
                                        <i className="fas fa-chevron-down dropdown-icon"></i>
                                      </div>
                                    )}
                                    {isNew && (
                                      <input
                                        type="text"
                                        placeholder="Type your justification here"
                                        className="form-control justification-input"
                                        value={item.justification || ""}
                                        onChange={(e) =>
                                          handleLocalInputChange(index, "justification", e.target.value)
                                        }
                                      />
                                    )}
                                  </td>
                                  <td>
                                    <input 
                                      readOnly 
                                      value={item.quantity === "" || item.quantity == null ? "" : item.quantity} 
                                      onChange={(e) => handleLocalInputChange(index, 'quantity', e.target.value)} 
                                      className="form-control" 
                                    />
                                  </td>
                                  <td>
                                    <input 
                                      step="0.01" 
                                      readOnly 
                                      value={formatCurrency(Number(item.unitPrice) || 0)} 
                                      onChange={(e) => handleLocalInputChange(index, 'unitPrice', e.target.value)} 
                                      className="form-control" 
                                    />
                                  </td>
                                  <td>
                                    <input 
                                      step="0.01" 
                                      readOnly 
                                      value={formatCurrency(Number(item.actualSpent) || 0)} 
                                      onChange={(e) => handleLocalInputChange(index, 'actualSpent', e.target.value)} 
                                      className="form-control" 
                                    />
                                  </td>
                                  <td>
                                    {isNew ? (
                                      <>
                                        <label><input type="checkbox" checked={item.attachmentType === "physical"} onChange={() => handleSupportDocumentsCheckboxChange(index, "physical")} className="the-checkbox-input" />Physical attachments</label>
                                        <label style={{ marginLeft: 8 }}><input type="checkbox" checked={item.attachmentType === "digital"} onChange={() => handleSupportDocumentsCheckboxChange(index, "digital")} className="the-checkbox-input" />Digital attachments</label>
                                        <br />
                                        {item.attachmentType === "digital" && (
                                          <div className="custom-file-input-container">
                                            <label className="custom-file-input-label">
                                              <input type="file" id={`blasting-support-documents-${index}`} name={`blastingFiles[${index}]`} className="hidden-file-input" accept="application/pdf" multiple onChange={(e) => handleFileChange(index, e)} />
                                              <span className="custom-file-text">Choose Files</span>
                                              <span className="plus-symbol">+</span>
                                            </label>
                                          </div>
                                        )}
                                        {item.selectedFiles && item.selectedFiles.length > 0 && (
                                          <div className="selected-files"><b>Selected Files:</b><ul>{item.selectedFiles.map((file, fi) => <li key={fi}>{file.name}</li>)}</ul></div>
                                        )}
                                      </>
                                    ) : (
                                      (item.supportDocuments && item.supportDocuments.length > 0) ? item.supportDocuments.map((doc) => (
                                        <div key={doc.id} style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "0.35rem" }}>
                                          <a href={`${API_BASE}/api/files/view/${doc.id}`} target="_blank" rel="noopener noreferrer" title="View document">View</a>
                                          <a href={`${API_BASE}/api/files/${doc.id}`} download title="Download document">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                              <polyline points="7 10 12 15 17 10" />
                                              <line x1="12" y1="15" x2="12" y2="3" />
                                            </svg>
                                          </a>
                                        </div>
                                      )) : <span>Has physical attachments</span>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ textAlign: 'center' }}>No blasting cost drivers</td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan="3" style={{ textAlign: 'right' }}><b>Totals:</b></td>
                            <td>{formatCurrency(blastingLocalActualsTotal)}</td>
                            <td colSpan="2"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>


                 {/* ===== BLASTING ADVANCE, ACTUALS & VARIANCE TABLE ===== */}
                <div className="details-group">
                  <div id="advance-variance-wrapper">
                    <h3>Blasting Advance, Actuals & Variance</h3>
                    
                      <table className="table-bordered">
                        <thead>
                          <tr>
                            <th>Cost Driver</th>
                            <th>Advance</th>
                            <th>Actual Spent</th>
                            <th>Variance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {local.blastingCostDriverActuals && local.blastingCostDriverActuals.length > 0 ? (
                            local.blastingCostDriverActuals.map((cDriver, idx) => {
                              const advanceRow = (surrender.blastingAdvanceActualsAndVariances || [])[idx] || {};
                              const advance = Number(advanceRow.advance || 0);
                              const costDriverLabel = cDriver.costDriver || cDriver.customCostDriver || advanceRow.costDriver || "";
                              const actualSpent = Number(cDriver.actualSpent || 0);
                              const variance = advance - actualSpent;
                              const isNew = !!cDriver.isNew;

                              return (
                                <tr key={`blasting-adv-${idx}`} className={isNew ? "new-row" : ""}>
                                  <td><strong>{idx + 1}. </strong><input type="text" value={costDriverLabel} readOnly className="read-only" /></td>
                                  <td><input type="text" value={formatCurrency(advance)} readOnly className="read-only" /></td>
                                  <td><input type="text" value={formatCurrency(actualSpent)} readOnly className="read-only" /></td>
                                  <td><input type="text" value={formatCurrency(variance)} readOnly className="read-only" /></td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="4" style={{ textAlign: 'center' }}>No blasting cost drivers</td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td style={{ textAlign: "right" }}><b>Totals:</b></td>
                            <td><input type="text" value={formatCurrency(blastingAdvanceTotals)} readOnly className="read-only" /></td>
                            <td><input type="text" value={formatCurrency(blastingLocalActualsTotal)} readOnly className="read-only" /></td>
                            <td><input type="text" value={formatCurrency(blastingVarianceTotal)} readOnly className="read-only" /></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>


                  

                  <div className="details-group">
                    <div id="cost-drivers-wrapper">
                      <h3>Cost Drivers - Actuals</h3>
                      <table className="table-bordered">
                        <thead>
                          <tr>
                            <th>Cost Driver</th>
                            <th>Quantity</th>
                            <th>Unit Price</th>
                            <th>Actual Spent</th>
                            <th>Support Documents</th>
                          </tr>
                        </thead>
                        <tbody>
                                  {Array.isArray(local.costDriverActuals) &&
                                    local.costDriverActuals.map((item, index) => {
                                      const isNew = !!item.isNew;
                                      return (
                                        <tr key={index} className={isNew ? "new-row" : ""}>
                                          <td>
                                            {item.isCustom ? (
                                              <input
                                                type="text"
                                                value={item.costDriver}
                                                onChange={(e) =>
                                                  handleCustomCostDriverChange(index, e.target.value)
                                                }
                                                className="form-control"
                                                placeholder="Type the Cost Driver"
                                              />
                                            ) : (
                                              <div className="dropdown-wrapper">
                                                {isNew && (
                                                  <span className="over-expenditure-text">
                                                    Over-expenditure
                                                  </span>
                                                )}
                                                <select
                                                  value={item.costDriver}
                                                  onChange={(e) =>
                                                    handleLocalInputChange(index, "costDriver", e.target.value)
                                                  }
                                                  className="form-control cost-driver-dropdown"
                                                >
                                                  <option value="">Select Cost Driver</option>
                                                  <option value="FCI Staff Perdiem">FCI Staff Perdiem</option>
                                                  <option value="Partners DSA">Partners DSA</option>
                                                  <option value="Government Staff DSA -AEDC, AEDO LVCDO">
                                                    Government Staff DSA -AEDC, AEDO LVCDO
                                                  </option>
                                                  <option value="Field Staff DSA">Field Staff DSA</option>
                                                  <option value="Venue/Hall Hire">Venue/Hall Hire</option>
                                                  <option value="Snacks">Snacks</option>
                                                  <option value="Refreshments">Refreshments</option>
                                                  <option value="Lunch Allowance">Lunch Allowance</option>
                                                  <option value="Transport Refund">Transport Refund</option>
                                                  <option value="Stationery">Stationery</option>
                                                  <option value="Scanning, printing & photocopy">
                                                    Scanning, printing & photocopy
                                                  </option>
                                                  <option value="Training Materials">
                                                    Training Materials
                                                  </option>
                                                  <option value="PA System hire">PA System hire</option>
                                                  <option value="Genset Hire">Genset Hire</option>
                                                  <option value="Vehicle Hire">Vehicle Hire</option>
                                                  <option value="Vehicle Fuel">Vehicle Fuel</option>
                                                  <option value="Toll Gate Fee">Toll Gate Fee</option>
                                                  <option value="Other">Other</option>
                                                </select>
                                                <i className="fas fa-chevron-down dropdown-icon"></i>
                                              </div>
                                            )}
                                            {isNew && (
                                              <input
                                                type="text"
                                                placeholder="Type your justification here"
                                                className="form-control justification-input"
                                                value={item.justification || ""}
                                                onChange={(e) =>
                                                  handleLocalInputChange(index, "justification", e.target.value)
                                                }
                                              />
                                            )}

                     </td>                               
                     <td><input readOnly value={item.quantity === "" || item.quantity == null ? "" : item.quantity} onChange={(e) => handleLocalInputChange(index, 'quantity', e.target.value)} className="form-control" /></td>
                                <td><input step="0.01" readOnly value={formatCurrency( Number(item.unitPrice) || 0 )} onChange={(e) => handleLocalInputChange(index, 'unitPrice', e.target.value)} className="form-control" /></td>
                                <td><input step="0.01" readOnly value={formatCurrency( Number(item.actualSpent) || 0 )} onChange={(e) => handleLocalInputChange(index, 'actualSpent', e.target.value)} className="form-control" /></td>

                                <td>
                                  {isNew ? (
                                    <>
                                      <label><input type="checkbox" checked={item.attachmentType === "physical"} onChange={() => handleSupportDocumentsCheckboxChange(index, "physical")} className="the-checkbox-input" />Physical attachments</label>
                                      <label style={{ marginLeft: 8 }}><input type="checkbox" checked={item.attachmentType === "digital"} onChange={() => handleSupportDocumentsCheckboxChange(index, "digital")} className="the-checkbox-input" />Digital attachments</label>
                                      <br />
                                      {item.attachmentType === "digital" && (
                                        <div className="custom-file-input-container">
                                          <label className="custom-file-input-label">
                                            <input type="file" id={`support-documents-${index}`} name={`files[${index}]`} className="hidden-file-input" accept="application/pdf" multiple onChange={(e) => handleFileChange(index, e)} />
                                            <span className="custom-file-text">Choose Files</span>
                                            <span className="plus-symbol">+</span>
                                          </label>
                                        </div>
                                      )}
                                      {item.selectedFiles && item.selectedFiles.length > 0 && (
                                        <div className="selected-files"><b>Selected Files:</b><ul>{item.selectedFiles.map((file, fi) => <li key={fi}>{file.name}</li>)}</ul></div>
                                      )}
                                      {showPopup && <div className="popup-overlay"><div className="popup"><h4>Not a PDF</h4><p>{popupMessage || "The file you selected is not a PDF."}</p><button onClick={closePopup} className="btn btn-primary">OK</button></div></div>}
                                    </>
                                  ) : (
                                    (item.supportDocuments && item.supportDocuments.length > 0) ? item.supportDocuments.map((doc) => (
                                      <div key={doc.id} style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "0.35rem" }}>
                                        <a href={`${API_BASE}/api/files/view/${doc.id}`} target="_blank" rel="noopener noreferrer" title="View document">View</a>
                                        <a href={`${API_BASE}/api/files/${doc.id}`} download title="Download document">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7 10 12 15 17 10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                          </svg>
                                        </a>
                                      </div>
                                    )) : <span>Has physical attachments</span>
                                  )}
                                </td>

                              </tr>
                            );
                          })}
                        </tbody>

                        <tfoot>
                          <tr>
                            <td colSpan="3" style={{ textAlign: 'right' }}><b>Totals:</b></td>
                            <td>{formatCurrency(localActualsTotal)}</td>
                            <td colSpan="2"></td>
                          </tr>
                        </tfoot>
                      </table>

                    </div>
                  </div>

                   
                  <div className="details-group">
                    <div id="advance-variance-wrapper">
                      <h3>Advance, Actuals & Variance</h3>
                      <table className="table-bordered">
                        <thead><tr><th>Cost Driver</th><th>Advance</th><th>Actual Spent</th><th>Variance</th></tr></thead>
                        <tbody>
                          {local.costDriverActuals.map((cDriver, idx) => {
                            const advanceRow = (surrender.advanceActualsAndVariances || [])[idx] || {};
                            const advance = Number(advanceRow.advance || 0);
                            const costDriverLabel = cDriver.costDriver || cDriver.customCostDriver || advanceRow.costDriver || "";
                            const actualSpent = Number(cDriver.actualSpent || 0);
                            const variance = advance - actualSpent;
                            const isNew = !!cDriver.isNew;

                            return (
                              <tr key={`adv-${idx}`} className={isNew ? "new-row" : ""}>
                                <td><strong>{idx + 1}. </strong><input type="text" value={costDriverLabel} readOnly className="read-only" /></td>
                                <td><input type="text" value={formatCurrency(advance)} readOnly className="read-only" /></td>
                                <td><input type="text" value={formatCurrency(actualSpent)} readOnly className="read-only" /></td>
                                <td><input type="text" value={formatCurrency(variance)} readOnly className="read-only" /></td>
                              </tr>
                            );
                          })}
                        </tbody>

                        <tfoot>
                          <tr>
                            <td style={{ textAlign: "right" }}><b>Totals:</b></td>
                            <td ><input type="text" value={formatCurrency(advanceTotals)} readOnly className="read-only" /></td>
                            <td ><input type="text" value={formatCurrency(localActualsTotal)} readOnly className="read-only" /></td>
                            <td ><input type="text" value={formatCurrency(varianceTotal)} readOnly className="read-only" /></td>
                          </tr>
                        </tfoot>
                      </table>

                      {theUserType === "Surrender Reviewer" && (
                        <div className="variance-summary">
                          {totalVariance > EPS && (
                            <p>
                              <i>According to the above,</i> <br />
                              {surrender?.staffName || "The submitter"} has{" "}
                              <strong>{formatCurrencyForSecondTable(totalVariance)}</strong> remaining.
                              <br />
                              <br />
                              Please cross-check and confirm. <br />
                            </p>
                          )}
                          {totalVariance < -EPS && (
                            <p>
                              <i>According to the above,</i> <br />
                              {surrender?.staffName || "The submitter"} has overspent by{" "}
                              <strong>{formatCurrencyForSecondTable(Math.abs(totalVariance))}</strong>.
                              <br />
                              <br />
                              Please cross-check and confirm. <br />
                            </p>
                          )}
                          {isZeroVariance && (
                            <p>
                              <i>According to the above,</i> <br />
                              {surrender?.staffName || "The submitter"} has spent all the money that was
                              advanced to him/her, which implies that he/she doesn't owe any money to the
                              office and the office doesn't owe any money to him/her. <br />
                              <br />
                              Please cross-check and confirm. <br />
                            </p>
                          )}
                        </div>
                      )}


                  <div className="reviewed-by-section" style={{ marginTop: 20 }}>
                    <h4>Reviewed by:</h4>

                    <div className="reviewed-by-list" style={{ display: "flex", gap: 20, alignItems: "flex-end", flexWrap: "wrap" }}>
                      {(surrender.reviewHistory || []).length === 0 ? (
                        <div style={{ color: "#666" }}> ---- </div>
                      ) : (
                        (surrender.reviewHistory || []).map((h) => (
                          <div key={h.id} className="reviewer-item" style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 120 }}>
                            {h.signatureFilePath ? (
                              <img
                                src={
                                  h.signatureFilePath.startsWith("http") 
                                    ? h.signatureFilePath 
                                    : `${process.env.REACT_APP_STATIC_BASE_URL}${h.signatureFilePath}`
                                }
                                alt={`${h.fullName} signature`}
                                style={{ 
                                  width: 120, 
                                  height: 60, 
                                  objectFit: "contain", 
                                  border: "1px solid #eee", 
                                  padding: 6, 
                                  background: "#fff" 
                                }}
                                onError={(e) => {
                                  console.error("Failed to load reviewer signature:", h.signatureFilePath);
                                  e.target.style.display = 'none';
                                }}
                              />
                            ) : (
                              <div style={{ 
                                width: 120, 
                                height: 60, 
                                display: "flex", 
                                justifyContent: "center", 
                                alignItems: "center", 
                                color: "#999", 
                                border: "1px dashed #ddd" 
                              }}>
                                No signature
                              </div>
                            )}
                            <div style={{ marginTop: 8, fontSize: "0.95rem", textAlign: "center" }}>{h.fullName}</div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>

                      {surrender?.status && surrender.status.trim().toLowerCase() === "Surrender Review Process Complete" && (
              <div className="surrender-complete-variance" style={{ marginTop: 12 }}>
                {totalVariance > EPS && (
                  <div>
                    <FontAwesomeIcon icon={faDollarSign} className="surrender-currency-icon" />
                    <strong>Return:</strong> {formatCurrencyForSecondTable(totalVariance)} to the Office.
                  </div>
                )}

                {totalVariance < -EPS && (
                  <div>
                    <FontAwesomeIcon icon={faDollarSign} className="surrender-currency-icon" />
                    The Office owes you a refund of <strong>{formatCurrencyForSecondTable(Math.abs(totalVariance))}</strong>.
                  </div>
                )}

                {Math.abs(totalVariance) <= EPS && (
                  <div>
                    <FontAwesomeIcon icon={faDollarSign} className="surrender-currency-icon" />
                     No variance — nothing is owed by you or the Office.
                  </div>
                )}
              </div>
            )}



                  




                    </div>
                  </div>
                </div>
              </form>

              <PopupModal
                isVisible={showCompleteModal}
                onClose={handleCancelComplete}
                title="Confirm Completion"
                titleStyle="popup-modal-title"
                message="Are you sure you want to mark this surrender as complete?"
                icon="check-circle"
                iconColor="#007bff"
                iconBorder="popup-modal-icon-circle"
              >
                <div className="modal-actions">
                  <button 
                    onClick={handleConfirmComplete} 
                    className="btn btn-primary"
                    disabled={isCompleting}
                  >
                    {isCompleting ? (
                      <>
                        <FontAwesomeIcon icon="spinner" spin /> Processing...
                      </>
                    ) : (
                      'Yes, Complete'
                    )}
                  </button>
                  <button 
                    onClick={handleCancelComplete} 
                    className="btn btn-secondary ml-2"
                  >
                    Cancel
                  </button>
                </div>
              </PopupModal>

              {showPopup && (
                <PopupModal
                  isVisible={showPopup}
                  onClose={closePopup}
                  title="Notice"
                  message={popupMessage}
                  icon="exclamation-triangle"
                  iconColor="#dc3545"
                >
                  <button onClick={closePopup} className="btn btn-primary">OK</button>
                </PopupModal>
              )}
            </div>
          </div>
        </div>

        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Farm Concern Internationalal 2025</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default ViewSurrender;
